<template>
    <el-card :body-style="{ padding: '0.5rem 1rem 1rem 1rem', }" 
        :class="`${$machineListStyle[element.status]} ${element.checked ? 'image-item__checked' : 'image-item__unchecked' }`" shadow="always">
        <div class="d-flex flex-column">
            <div class="d-flex flex-row justify-content-between align-items-center machine-item">
                <div class="d-flex flex-row align-items-center" style="font-family: Montserrat">
                    <div class="d-flex justify-content-center align-items-center" 
                        :class="`${element.status === 32773 || element.status === 10 ? 'blink_me' : '' }`" 
                        style=" border-radius: 1rem; height: 0.75rem; width: 0.75rem; " 
                        :style="`background-color: ${$machineStatusDotColor[element.status ] };`"></div>
                    <div class="ml-2 row-index-label">
                        # {{ index + 1 }}
                    </div>
                    <div v-if="element.isNotSupport" class="ml-2 not-support-label">
                        <i class="el-icon-close"></i>
                        <span class="ml-2">Not available, please
                            change package</span>
                    </div>
                    <div v-else class="d-flex flex-row">
                        <div v-if="element.hardwareFixation " class="ml-2 hardwareFixation">
                            <i class="fas fa-thumbtack"></i>
                            <span class="ml-2">Fixed MAC</span>
                        </div>
                        <div v-if="element.softwareLicenseEnabled " class="ml-2 softwareLicenseEnabled">
                            <i class="el-icon-key"></i>
                            <span class="ml-2">License</span>
                        </div>
                        <div v-if="element.fixedRental" class="ml-2 fixedRental">
                            <i class="el-icon-date"></i>
                            <span class="ml-2">Rental Plan</span>
                        </div>
                        <div v-if=" element.isDisconnectedInternet " class="ml-2 isDisconnectedInternet">
                            <i class="el-icon-date"></i>
                            <span class="ml-2">Disconnected
                                Internet</span>
                        </div>
                        <el-tooltip class="item" effect="dark" 
                            :content="`Shutdown at : ${actions.formatTime( element.schedulerMachineShutdownMachineStartAt )}`" 
                            placement="top">
                            <div v-if=" element.schedulerMachineShutdownMachineEnabled " class="ml-2 schedulerMachineShutdownMachineEnabled">
                                <i class="el-icon-switch-button"></i>
                                <span class="ml-1">
                                    {{ element.schedulerMachineShutdownMachineTimeRemaining }}
                                </span>
                            </div>
                        </el-tooltip>
                    </div>
                </div>
                <div class="d-flex flex-row align-items-center">
                    <div class="mr-4" v-if="element.snsCount">
                        <el-tooltip :content="`This image has ${element.snsCount } ${element.snsCount > 1 ? 'snapshots' : 'snapshot' }. Click to show more.`" 
                            placement="top" effect="light">
                            <div class="snsCount">
                                <span
                                    v-if=" !(element.status === 3 || element.status === 8 || element.status === 1) || !element.bootReady"
                                     style="opacity: 0.5" class="text-primary">
                                    {{ element.snsCount }}
                                    <i class="el-icon-camera"></i>
                                </span>
                                <el-button v-else type="text" class="pb-0 pt-0 text-primary" @click="
                                    actions.processingEvent(
                                        {
                                            event: 'action',
                                            data: {
                                                type: $action.OPEN_POPUP_SNAPSHOT_IMAGE,
                                                data: element,
                                            },
                                        }
                                    )
                                    ">
                                    {{ element.snsCount }}
                                    <i class="el-icon-camera"></i>
                                </el-button>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="vhdxLength">
                        {{ element.vhdxLength | formatSize }}
                    </div>
                    <ContextMenu class="ml-2" :element="element" @processingEvent="actions.processingEvent " />
                </div>
            </div>
            <div class="d-flex flex-row pt-3 mt-2" style="border-top: 1px solid #e0e0e0">
                <div class="hidden-sm-and-down mr-5">
                    <Lable :element="element" />
                </div> 
                <Information :element="element" />
                <div style="display: flex" class="hidden-sm-and-down align-items-end">
                    <Action :element="element" @processingEvent="actions.processingEvent " />
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import Lable from "@/views/component/RentalService/Lable";
import ContextMenu from "@/views/component/RentalService/ContextMenu";
import Action from "@/views/component/RentalService/Action";
import Information from "@/views/component/RentalService/Information";
export default {
    components: {        
        Action,
        Lable,
        ContextMenu,
        Information,
    },
    props :{ 
        element: {
            type: Object,
            default() {
                return {}
            }
        },
        index: {
            type: Number,
            default() {
                return -1
            }
        },
        actions: {
            type: Object,
            default() {
                return {}
            }
        },
    }
}
</script>